/** The Add category (C8) form's draft and its clean state (TMMAPP-0108). */
import type { CategoryKind } from '@/api/categories';
import { sameValues } from '@/shared/useDirty';

export interface CategoryDraft {
  kind: CategoryKind;
  name: string;
  description: string;
  taxReportable: boolean;
}

export const EMPTY_CATEGORY_DRAFT: CategoryDraft = {
  kind: 'EXPENSE',
  name: '',
  description: '',
  taxReportable: false,
};

export function isCategoryDraftDirty(draft: CategoryDraft): boolean {
  return !sameValues(draft, EMPTY_CATEGORY_DRAFT);
}
